import coveredEntry from "./assets/cctv/covered-entry-camera.jpg";
import gate from "./assets/cctv/gate-camera.jpg";
import cableRouting from "./assets/cctv/exterior-cable-routing.jpg";
import overhang from "./assets/cctv/outdoor-overhang-camera.jpg";
import exteriorWall from "./assets/cctv/exterior-wall-camera.jpg";
import monitoring from "./assets/cctv/monitoring-station.jpg";
import column from "./assets/cctv/column-camera.jpg";
import ceiling from "./assets/cctv/ceiling-camera.jpg";
import indoorCorner from "./assets/cctv/indoor-corner-camera.jpg";
import stairwell from "./assets/cctv/stairwell-camera.jpg";

const photos = [
  { image: monitoring, title: "Central Monitoring Station", description: "A wall-mounted equipment cabinet and display bring multiple camera views together at one monitoring point." },
  { image: coveredEntry, title: "Covered Entry Camera", description: "A camera mounted beneath the entrance beam, with cabling routed along the wall and ceiling." },
  { image: gate, title: "Gate Camera", description: "A camera positioned above the metal gate to overlook the entrance area." },
  { image: cableRouting, title: "Exterior Cable Routing", description: "Surface-mounted cable trunking follows the exterior wall from the upper level to the camera area." },
  { image: overhang, title: "Outdoor Overhang Camera", description: "A camera installed beneath a roof overhang, facing the open area beside the building." },
  { image: exteriorWall, title: "Exterior Wall Camera", description: "A wall-mounted camera overlooks the outdoor area from the building corner." },
  { image: column, title: "Column-Mounted Camera", description: "A camera attached to a structural column, with cabling following the overhead beam." },
  { image: ceiling, title: "Ceiling-Mounted Camera", description: "An overhead camera installation with visible power connections and cable routing along the beam." },
  { image: indoorCorner, title: "Indoor Corner Camera", description: "An indoor camera mounted near the ceiling, with cable trunking following the room's upper edges." },
  { image: stairwell, title: "Stairwell Camera", description: "A camera positioned above the metal railing to overlook the stairway and passage area." },
];

export default function CCTVProject() {
  return (
    <article className="overflow-hidden">
      <div className="border-b border-white/10 p-6 sm:p-8">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#a8cdef]">Featured hardware project</p>
        <h4 className="mt-4 text-sm font-semibold text-slate-100">Project overview</h4>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-slate-300">We installed eight CCTV cameras at an apartment building to cover entrances, stairways, indoor passages, and outdoor areas. The installation included camera mounting, cable routing, and a central monitoring station with an equipment cabinet and a display for viewing multiple camera feeds.</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {["Camera installation", "Indoor & outdoor coverage", "Cable routing", "Central monitoring"].map((tag) => (
            <span key={tag} className="rounded-full bg-sky-400/10 px-3 py-1 text-xs text-sky-200">{tag}</span>
          ))}
        </div>
      </div>
      <div className="p-6 sm:p-8">
        <h4 className="text-lg font-semibold text-white">Installation gallery</h4>
        <p className="mt-2 text-sm text-slate-400">Ten photos documenting the installation. Select any photo to view it at full size.</p>
        <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {photos.map((photo) => (
            <figure key={photo.title} className="overflow-hidden rounded-2xl border border-white/10 bg-[#07141f]/60">
              <a href={photo.image} target="_blank" rel="noreferrer" aria-label={`View full photo: ${photo.title} (opens in a new tab)`} className="block bg-slate-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-300">
                <img src={photo.image} alt={photo.description} width="828" height="1104" loading="lazy" className="aspect-[3/4] h-auto w-full object-contain" />
              </a>
            </figure>
          ))}
        </div>
      </div>
    </article>
  );
}
